import { Box } from '@mui/material';
import AgMoodItem from '../AgMoodItem';
import AgTypography from '../../Styles/AgTypography';
import { AgColor } from '../../Styles/AgColor';
import { useIntl } from 'react-intl';
import { useEffect, useState } from 'react';
import { MOOD_TYPE } from '../../../Constants';

const AgMoodSelector = ({ setMood }: {setMood?: Function}) => {
  const messages = useIntl().formatMessage;
  const [selected, setSelected] = useState<MOOD_TYPE>();

  useEffect(()=>{
    if(setMood) setMood(selected);
  }, [selected, setMood]);

  return (
    <Box sx={{ width: '528px', height: '114px' }}>
      <Box sx={{ display: 'flex', columnGap: '16px' }}>
        <AgMoodItem mood={MOOD_TYPE.VerySatisfied} onClick={()=> setSelected(MOOD_TYPE.VerySatisfied)} selected={selected === MOOD_TYPE.VerySatisfied}/>
        <AgMoodItem mood={MOOD_TYPE.Satisfied} onClick={()=> setSelected(MOOD_TYPE.Satisfied)} selected={selected === MOOD_TYPE.Satisfied}/>
        <AgMoodItem mood={MOOD_TYPE.Dissatisfied} onClick={()=> setSelected(MOOD_TYPE.Dissatisfied)} selected={selected === MOOD_TYPE.Dissatisfied}/>
        <AgMoodItem mood={MOOD_TYPE.VeryDissatisfied} onClick={()=> setSelected(MOOD_TYPE.VeryDissatisfied)} selected={selected === MOOD_TYPE.VeryDissatisfied}/>
      </Box>
      <Box sx={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between' }}>
        <AgTypography sx={{ color: AgColor.grey8 }} contentStyle='AP.Paragraph.Medium.Regular' component='p'>{messages({ id: 'VERY_SATISFIED' })}</AgTypography>
        <AgTypography sx={{ color: AgColor.grey8 }} contentStyle='AP.Paragraph.Medium.Regular' component='p'>{messages({ id: 'VERY_DISSATISFIED' })}</AgTypography>
      </Box>
      
    </Box>
  );
};

export default AgMoodSelector;